import { Component, Input, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ViewerConstants } from "../../../shared/model/viewer-constants";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "feature-info",
  templateUrl: "./feature-info.component.html",
  styleUrls: ["./feature-info.component.scss"],
  standalone: false,
})
export class FeatureInfoComponent {
  @ViewChild("matTabGroup") matTabGroup;

  selected = new FormControl(0);

  private _featuresData: any;

  private _layer: any;

  @Input() set featuresData(featuresData: any[]) {
    this._featuresData = featuresData;
  }

  get featuresData(): any[] {
    return this._featuresData;
  }

  @Input() set layer(layer: any) {
    this._layer = layer;
  }

  get layer(): any {
    return this._layer;
  }

  isPoint(feature): boolean {
    return feature.geometry?.type === ViewerConstants.GEOMETRY_TYPE.Point;
  }

  getFillColorLayer() {
    return this.layer?.style ? JSON.parse(this.layer.style).defaultSetting.colorFill : "rgb(46, 111, 255)";
  }
}
